import { render, staticRenderFns } from "./CreateIndustryTypePopup.vue?vue&type=template&id=ddf2916e"
import script from "./CreateIndustryTypePopup.vue?vue&type=script&lang=js"
export * from "./CreateIndustryTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports